import React from 'react';
import ConnectorDeals from './ConnectorDeals';
import { InProgressInvestorsPanel } from './investorsPanel';
import { ConnectorDeal, ConnectorDealStatus, ReferralStatus } from '../../../types/types';
import { useConnectorDeals } from '../../../contexts';

const ConnectorDealsInProgress = () => {
  const { inProgressDeals, inProgressDealsTotalCount } = useConnectorDeals();
  const renderRightPanelContent = (deal: ConnectorDeal) => {
    const sentInvestors = {
      waitingCount: deal.referrals.filter((referral) => referral.status === ReferralStatus.Pending).length,
      interestedCount: deal.referrals.filter((referral) => referral.status === ReferralStatus.Accepted).length,
      passedCount: deal.referrals.filter((referral) => referral.status === ReferralStatus.Declined).length
    };
    return (
      <InProgressInvestorsPanel
        recommendedInvestorsCount={deal.totalMatchCount}
        sentInvestors={sentInvestors}
        entProfileId={deal.entrepreneurProfileId}
      />
    );
  };
  return (
    <ConnectorDeals
      renderRightPanelContent={renderRightPanelContent}
      status={ConnectorDealStatus.InProgress}
      deals={inProgressDeals}
      totalCount={inProgressDealsTotalCount}
    />
  );
};

export default ConnectorDealsInProgress;
